var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#arrow_svg__mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.35 16.65a1.91 1.91 0 01-2.824-2.564l.124-.136L6.602 9 1.65 4.05a1.91 1.91 0 01-.124-2.564l.124-.136a1.91 1.91 0 012.564-.124l.136.124 6.3 6.3a1.91 1.91 0 01.124 2.564l-.124.136-6.3 6.3z"
  }))));
}
export default SvgArrow;